export default "__VITE_ASSET__26368153__"